/**
 * Mazzed — small, safe site-wide micro-interactions.
 *
 * This file only ever listens to the theme's own public `cart:update`
 * event (see assets/events.js / ThemeEvents.cartUpdate) and toggles a CSS
 * class on the cart icon element. It never touches cart, product-form or
 * checkout logic, so it cannot interfere with add-to-cart functionality.
 */
(() => {
  const CART_UPDATE_EVENT = 'cart:update';
  const PULSE_CLASS = 'mazzed-cart-pulse';

  document.addEventListener(CART_UPDATE_EVENT, () => {
    const icon = document.querySelector('cart-icon');
    if (!icon) return;

    icon.classList.remove(PULSE_CLASS);
    // Force a reflow so the animation restarts on consecutive additions.
    void icon.offsetWidth;
    icon.classList.add(PULSE_CLASS);
  });
})();
